module.exports = __webpack_public_path__ + "assets/img/1521587607738_.pic_hd.08732e5b.jpg";